<template>
  <div v-if="attachments && attachments.length" class="chat-img-gallery">
    <button v-for="a in attachments"
            :key="a.id"
            type="button"
            class="chat-img-gallery__thumb"
            :title="a.fileName"
            @click="active = a">
      <img :src="a.url" :alt="a.fileName || 'Image'" loading="lazy" @load="$emit('loaded')">
    </button>

    <teleport to="body">
      <div v-if="active"
           class="chat-img-lightbox"
           role="dialog"
           aria-modal="true"
           :aria-label="active.fileName || 'Image'"
           @click="active = null">
        <button type="button" class="chat-img-lightbox__close" title="Close" @click.stop="active = null">
          <i class="fa-solid fa-xmark"></i>
        </button>
        <img :src="active.url" :alt="active.fileName || 'Image'">
      </div>
    </teleport>
  </div>
</template>

<script>
  // Thumbnails for one message's attachments, plus a click-to-enlarge lightbox
  // (Esc or click anywhere closes). Emits `loaded` as each thumbnail finishes loading so
  // the parent can re-pin its scroll to the newest message.
  export default {
    name: 'ChatImageGallery',
    props: {
      attachments: { type: Array, default: () => [] }
    },
    emits: ['loaded'],
    data() {
      return { active: null };
    },
    watch: {
      active(val) {
        if (val) document.addEventListener('keydown', this.onKey);
        else document.removeEventListener('keydown', this.onKey);
      }
    },
    beforeUnmount() {
      document.removeEventListener('keydown', this.onKey);
    },
    methods: {
      onKey(evt) {
        if (evt.key === 'Escape') {
          evt.stopPropagation();
          this.active = null;
        }
      }
    }
  };
</script>

<style scoped>
  .chat-img-gallery {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 6px;
  }

  .chat-img-gallery__thumb {
    padding: 0;
    border: none;
    background: transparent;
    cursor: zoom-in;
    border-radius: 8px;
    overflow: hidden;
    line-height: 0;
  }

  .chat-img-gallery__thumb img {
    max-width: 200px;
    max-height: 200px;
    border-radius: 8px;
    display: block;
    object-fit: cover;
  }

  .chat-img-lightbox {
    position: fixed;
    inset: 0;
    z-index: 20000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(10, 20, 40, .82);
    cursor: zoom-out;
  }

  .chat-img-lightbox img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 8px;
    box-shadow: 0 16px 40px rgba(0, 0, 0, .4);
  }

  .chat-img-lightbox__close {
    position: absolute;
    top: 14px;
    right: 18px;
    border: none;
    background: transparent;
    color: #fff;
    font-size: 2.2rem;
    cursor: pointer;
  }
</style>
